/*
 * patient-diagnosis (schema)
 */
import { boolean, integer, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { patients } from "../patient/patient.schema"
import { diagnoses } from "../diagnosis/diagnosis.schema"
import { users } from "../user/user.schema"

export const patientDiagnoses = schema.table("patient_diagnoses", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id").notNull().references(() => patients.id, { onDelete: "cascade" }),
	diagnosisId: uuid("diagnosis_id").notNull().references(() => diagnoses.id, { onDelete: "restrict" }),

	// --- General ---
	type: varchar("type", { length: 32 }).notNull().default("secondary"), // primary | secondary
	yearDiagnosed: integer("year_diagnosed"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
